import React from "react";

const FAQ_ITEMS = [
  {
    question: "Where is the wedding?",
    answer: "Historic Ashland: 6219 Lincoln Hwy, Wrightsville, PA 17368",
  },
  {
    question: "Where should I park?",
    answer: "There will be parking on premesis with proper accessibility.",
  },
  {
    question: "What is the dress code?",
    answer: "Semi-formal to formal.",
  },
  {
    question: "When should I RSVP?",
    answer: "Please submit your RSVP by June 18th, 2027.",
  },
  {
    question: "Can I bring a plus-one or children?",
    answer: "A plus one is allowed if specified in your invite, and children are welcome!",
  },
  {
    question: "Is the venue accessible?",
    answer: "Yes, there are ramps and golf carts available for those who might need them.",
  },
  {
    question: "Where should out-of-town guests stay?",
    answer: "There are AirBnB's available nearby. If you would prefer a hotel, there is a Hampton Inn nearby at 12 N 2nd St, Columbia, PA 17512",
  },
];

export default function Faq() {
  return (
    <section className="guest-page faq-page">
      <p className="eyebrow">Good to know</p>
      <h1>Frequently asked questions</h1>
      <p className="page-intro">
        Everything you need for a relaxed and wonderful celebration.
      </p>

      <div className="faq-list">
        {FAQ_ITEMS.map((item) => (
          <details className="faq-item" key={item.question}>
            <summary>{item.question}</summary>
            <p>{item.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
